import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, PageHeader, StatusPill, Empty, inputCls } from "../../components/dash/Kit";
import { api } from "../../lib/api";

export default function AdminCustomers() {
  const [rows, setRows] = useState([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/customers").then((r) => setRows(r.data)).finally(() => setLoading(false));
  }, []);

  const visible = rows.filter((r) =>
    `${r.business_name} ${r.first_name} ${r.last_name} ${r.email}`.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="space-y-6" data-testid="admin-customers-page">
      <PageHeader
        title="Customers"
        body="Every customer account, their package and profile status."
        action={
          <input
            data-testid="admin-customer-search"
            className={`${inputCls} sm:w-72`}
            placeholder="Search customers"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        }
      />

      {loading ? (
        <Card testId="admin-customers-loading">Loading customers…</Card>
      ) : visible.length === 0 ? (
        <Empty testId="admin-customers-empty" title="No customers found" />
      ) : (
        <Card testId="admin-customers-table" className="overflow-x-auto p-0">
          <table className="w-full min-w-[900px] text-left text-sm">
            <thead className="border-b border-slate-200 text-xs uppercase tracking-wide text-slate-400">
              <tr>
                {["Business", "Contact", "Package", "Subscription", "Brand Profile", "Open Revisions", ""].map((h) => (
                  <th key={h} className="px-5 py-3 font-semibold">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {visible.map((c) => (
                <tr key={c.id} data-testid={`admin-customer-row-${c.id}`}>
                  <td className="px-5 py-3 font-semibold text-slate-900">{c.business_name}</td>
                  <td className="px-5 py-3 text-slate-600">
                    {c.first_name} {c.last_name}
                    <span className="block text-xs text-slate-400">{c.email}</span>
                  </td>
                  <td className="px-5 py-3 text-slate-600">{c.subscription?.package || "—"}</td>
                  <td className="px-5 py-3"><StatusPill status={c.subscription?.status || "—"} /></td>
                  <td className="px-5 py-3">
                    <StatusPill status={c.profile_completed ? "Completed" : "Information Required"} />
                  </td>
                  <td className="px-5 py-3 text-slate-600">{c.open_revisions}</td>
                  <td className="px-5 py-3">
                    <Link
                      to={`/admin/customers/${c.id}`}
                      data-testid={`admin-customer-open-${c.id}`}
                      className="rounded-xl border border-slate-300 px-3 py-2 text-xs font-semibold text-slate-800 hover:bg-slate-50"
                    >
                      Open
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
}
